import InfoCircle from '@carvana/icons/InfoCircle';
import Tooltip from '@carvana/tooltip'; // TODO Replace with latest Showroom
import PropTypes from 'prop-types';

import styled from 'styled-components';

const StyledText = styled.div`
  text-transform: uppercase;
  padding: 5px 0 7px 0;
  font-size: 26px;
  line-height: 28px;
  font-weight: 700;
  text-align: center;
`;

const TooltipStyled = styled(Tooltip)`
  color: ${p => p.theme.carvana.gray.dark};
  margin: 0 0 -18px 5px;
`;

const SubHeader = styled.div`
  color: ${p => p.theme.carvana.gray.dark};
  padding-bottom: 17px;
  font-size: 16px;
  line-height: 20px;
`;

const tooltipContent = (
  <div style={{ fontSize: '14px', lineHeight: '19px' }}>
    <b>Not applicable in:</b>
    <div>
      California, District of Columbia, Hawaii, Kentucky, Michigan, Montana,
      Ohio, and Virginia
    </div>
  </div>
);

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: space-between;
  justify-content: center;
`;

function TextLines({ top, bottom, tooltip, subheader1, subheader2 }) {
  return (
    <>
      <StyledText>
        <div>{top}</div>
        <Container>
          {bottom}{' '}
          {tooltip && (
            <TooltipStyled>
              <Tooltip.HoverElement>
                <InfoCircle width={15} height={15} />
              </Tooltip.HoverElement>
              <Tooltip.Content
                direction="up"
                offsetTooltip={{
                  left: -10
                }}
              >
                {tooltipContent}
              </Tooltip.Content>
            </TooltipStyled>
          )}
        </Container>
      </StyledText>
      {subheader1 && (
        <SubHeader>
          {subheader1 && <div>{subheader1}</div>}
          {subheader2 && <div>{subheader2}</div>}
        </SubHeader>
      )}
    </>
  );
}

TextLines.propTypes = {
  top: PropTypes.string.isRequired,
  bottom: PropTypes.string.isRequired,
  tooltip: PropTypes.bool,
  subheader1: PropTypes.string,
  subheader2: PropTypes.string
};

TextLines.defaultProps = {
  tooltip: false,
  subheader1: undefined,
  subheader2: undefined
};

export default TextLines;
